import { render } from "./LanguagePackage.vue?vue&type=template&id=745f4367&scoped=true"
import script from "./LanguagePackage.vue?vue&type=script&lang=js"
export * from "./LanguagePackage.vue?vue&type=script&lang=js"

import "./language-package.scss?vue&type=style&index=0&id=745f4367&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745f4367"]])

export default __exports__